import { DateInt8 } from "@cawita/core-front";
import { ApiData } from "@cawita/core-front/api";
import { CwtModel } from "../modules/crud";
import { Partner } from "./partner.model";

@CwtModel({ name: 'stay-creation-code', path: '/stayCreationCode' })
export class StayCreationCode extends ApiData {
    startDate: DateInt8; // NOT REALLY USED ANYMORE...
    endDate: DateInt8; // NOT REALLY USED ANYMORE...
    camping: Partner;
    code: string;

    public get partner(): Partner { return this.camping; }
    public set partner(v: Partner) { this.camping = v; }

    fieldDictionary() {
        return {
            ...super.fieldDictionary(),
            camping: Partner
        };
    }
}